const styles = (theme) => ({
  dialogTitlestyle: {
    padding: "16px 16px 8px 16px",
    display: "grid",
    gridTemplateColumns: "1fr auto 1fr",
    alignItems: "start",
  },
  dialogContents: {
    padding: "0px 16px 8px 16px",
  },
  dialog: {
    width: 470,
    backgroundColor: theme.gridBGColor,
  },
  confirmationMessage: {
    color: theme.TextColor,
    fontSize: theme.textFontSize,
    fontWeight: 400,
    marginBottom: 12,
    lineHeight: 1.5,
    textAlign: "center",
  },
  dialogFooter: {
    display: "flex",
    justifyContent: "flex-end",
    padding: 16,
  },
  confirmationContent: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  confirmationContentInner: {
    width: "100%",
    maxWidth: 438,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  closeButton: {
    gridColumn: 3,
    justifySelf: "end",
    alignSelf: "start",
  },
  errorIcon: {
    color: theme.errorBorderColor,
    fontSize: 48,
    marginBottom: 6,
  },
  titleContainer: {
    gridColumn: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    color: theme.TextColor,
    fontSize: theme.headerTextFontSize24,
    fontWeight: 600,
  },
  cardsContainerSection: {
    width: "80%",
    margin: "0 auto",
    marginTop: 16,
  },
});

export default styles;
